import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams } from "react-router-dom";
import { useState } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import {
  AlertService,
  ErrorService,
  FormService,
  UtilsService,
} from "@standard/services";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import DocumentTable from "./DocumentTable";

export default ({ history, url }) => {
  const { id, action } = useParams();
  const [errors, setErrors] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [disabled, setDisabled] = useState(action === "view");
  const [isLoading, setIsLoading] = useState(id ? true : false);

  const defaultValues = {
    id: id,
    name: "",
    active: true,
  };

  const reactHookForm = useForm({ defaultValues });

  useEffect(() => {
    if (id !== undefined) retrieveData(id);
  }, []);

  const retrieveData = (id) => {
    FormService.getRequest(url, id).then((result) => {
      reactHookForm.reset(result);
      setDocuments(
        result.documents.map((document) => {
          return {
            key: document._id,
            values: {
              name: document.name,
              assets: document.assets,
              assetsPreview: document.assetsPreview,
            },
          };
        })
      );
      setIsLoading(false);
    });
  };

  const isValidForm = (newData) => {
    const formErrors = [];
    if (documents.length > 0) {
      documents.map((item, itemIndex) => {
        const name = item.values.name;
        if (name.trim() === "")
          formErrors.push(
            `field "Name" in Documents is required at line ${itemIndex}`
          );
      });
    }

    if (formErrors.length === 0) return true;

    setErrors(formErrors);
    UtilsService.goToTop();
    return false;
  };

  const saveData = (newData) => {
    if (isValidForm(newData) === false) return;
    setIsLoading(true);

    const params = { ...newData, id: id };

    params.documents = documents.map((item, index) => {
      params[`assets[${index}]`] = item.values.assets;

      return {
        _id: item.key ?? undefined,
        name: item.values.name,
        deletedAssets:
          item.values.assetsPreview
            ?.filter((asset) => asset.isDelete === true)
            .map((asset) => asset._id) ?? [],
      };
    });

    FormService.submitRequestWithFile(url, params)
      .then(() => {
        setIsLoading(false);
        setErrors([]);
        history.push(`/${url}`);
      })
      .catch((err) => {
        console.log("Catch error", err);
        setIsLoading(false);
        setErrors(err);
      });
  };

  const onSubmit = (newData) => {
    AlertService.confirm("Do you want to save data").then((res) => {
      if (res === true) saveData(newData);
    });
  };

  let fields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      required: true,
      disabled: disabled,
    },

    {
      type: "custom",
      control: (
        <DocumentTable
          key="documents"
          values={documents}
          onChange={(newDocuments) => {
            setDocuments(newDocuments);
          }}
          onFileChange={(index, field) => {
            setDocuments((prev) => {
              return prev.map((item, itemIndex) => {
                if (itemIndex === index) item.values[field.name] = field.value;
                return item;
              });
            });
          }}
          disabled={disabled}
        />
      ),
    },

    {
      label: "Active",
      name: "active",
      type: "switch",
      disabled: disabled,
    },
  ];

  const fieldErrors = ErrorService.convertToArray(
    reactHookForm.formState.errors
  );

  return (
    <BoxContainer loading={isLoading} errors={errors.concat(fieldErrors)}>
      <DataForm
        enableSave={!disabled}
        refForm={reactHookForm}
        onSubmit={onSubmit}
        fields={fields}
        url={url}
      ></DataForm>
    </BoxContainer>
  );
};
